(function (Drupal) {
  Drupal.behaviors.popups = {
    attach: function (context, settings) {
      document.querySelectorAll("a").forEach(function (linkElement) {
        let link = linkElement.getAttribute("href");

        if (typeof link !== "undefined" && link?.indexOf("#") >= 0) {
          link = link.substring(link.indexOf("#"));
          linkElement.setAttribute("goto", link);
          linkElement.classList.add("scrollto");
        }
      });

      if (document.querySelector(".popup")) {
        document.querySelectorAll(".popup").forEach(function (popup) {
          popup.addEventListener("click", function (event) {
            if (!event.target.closest(".content")) {
              var videoPopupIframe = document.querySelector(
                ".video-popup iframe"
              );
              if (videoPopupIframe) {
                videoPopupIframe.setAttribute("src", "");
              }
              popup.classList.remove("opened");
              document.body.classList.remove("webform-popup-opened");
            }
          });
        });
      }

      if (document.querySelector(".popup-link")) {
        document.querySelectorAll(".popup-link").forEach(function (popupLink) {
          popupLink.addEventListener("click", function (e) {
            e.preventDefault();

            if (popupLink.getAttribute("target") == "video-popup") {
              const url = popupLink.getAttribute("youtubelink");
              const videoid = url.match(
                /(?:https?:\/\/)?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/
              );

              if (videoid !== null) {
                const videoIframe = document.querySelector(".video-popup iframe");

                if (videoIframe) {
                  videoIframe.setAttribute(
                    "src",
                    "https://www.youtube.com/embed/" +
                    videoid[1] +
                    "?autoplay=1"
                  );
                }
              } else {
                console.error("The youtube URL is not valid.");
              }

              const videoPopup = document.querySelector(".video-popup");

              if (videoPopup) {
                videoPopup.classList.add("opened");
              }
            } else {
              const closebutton =
                "<div class='popup-close'></div>";
                const target = popupLink.getAttribute("target");
                
                const bikeName = popupLink
                ?.closest(".one-bike")
                ?.querySelector(".bike-name")?.innerHTML;

                const targetPopup = document.querySelector(target);
              if (
                targetPopup &&
                targetPopup.classList.contains("webform-popup")
              ) {
                const editBikeInput = targetPopup.querySelector("#edit-bike");

                if (editBikeInput) {
                  editBikeInput.value = bikeName;
                }
              }

              if (targetPopup) {
                targetPopup.classList.add("opened");
                document.body.classList.add("webform-popup-opened");
                const h2Element = targetPopup.querySelector("h2");

                if (h2Element) {
                  h2Element.insertAdjacentHTML("afterend", closebutton);
                }
              }
            }
          });
        });
      }

      document.body.addEventListener("click", function (e) {
        if (e.target.classList.contains("popup-close")) {
          var videoPopupIframe = document.querySelector(".video-popup iframe");
          if (videoPopupIframe) {
            videoPopupIframe.setAttribute("src", "");
          }

          document.querySelectorAll(".popup").forEach(function (popup) {
            popup.classList.remove("opened");
          });

          document.body.classList.remove("webform-popup-opened");
        }
      });

      document.addEventListener("keyup", function (e) {
        if (e.code === 27) {
          const videoPopupIframe = document.querySelector(".video-popup iframe");
          
          if (videoPopupIframe) {
            videoPopupIframe.setAttribute("src", "");
          }

          document.querySelectorAll(".popup").forEach(function (popup) {
            popup.classList.remove("opened");
          });

          document.body.classList.remove("webform-popup-opened");
        }
      });
    },
  };
})(Drupal);
